module.exports = __webpack_public_path__ + "img/letter-img2.183e6fb6.png";